/*
 * Ordenador de la rejilla de la tienda.
 *
 * Sin JavaScript el formulario se envia con su boton, que esta en el HTML.
 * Con JavaScript el boton sobra: se esconde y el formulario se envia al
 * cambiar de opcion.
 */

document.querySelectorAll('[data-reda-orden]').forEach((formulario) => {
  const enviar = formulario.querySelector('.reda-orden__enviar');
  if (enviar) enviar.hidden = true;

  const lista = formulario.querySelector('select');
  if (!lista) return;

  lista.addEventListener('change', () => formulario.submit());
});
